export const getDateCodeStr = () => {
  const now = new Date()
  return now.toISOString().slice(0, 16).replaceAll(/([T:-])/g, '')
}